<template>
  <div>
    <div class="v-overlay v-overlay--active" style="z-index: 202"></div>
    <v-dialog v-model="open" persistent max-width="640px" :hide-overlay="this.$route.fullPath.includes('details')"
              attach="RealizationModal">
      <v-card>
        <form @submit.prevent="!isProcessing ? onSubmit() : null">
          <v-card-title>
            <span class="headline">Edytowanie wartości</span>
          </v-card-title>
          <v-card-text>
            <v-container class="pt-0" grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                    <v-text-field
                      label="Wartość"
                      v-validate="'required'"
                      type="number"
                      step="0.01"
                      v-model="price"
                      data-vv-name="wartość"
                      :error-messages="errors.collect('wartość')"
                      browser-autocomplete="off">
                    </v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey darken-1" flat @click="goBack">Anuluj</v-btn>
            <v-btn color="blue darken-1" flat :disabled="isProcessing" type="submit">Zapisz</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  /* eslint-disable no-unused-expressions */

  import {mapActions} from 'vuex';

  export default {
    name: 'EditPrice',
    data() {
      return {
        open: true,
        isProcessing: false,
        price: '',
      };
    },
    beforeMount() {
      this.fetchVoucherDetails(this.$route.params.voucherId)
        .then((response) => {
          this.price = response.price;
        });
    },
    // watch: {
    //   voucherDate(newVal) {
    //     this.expiredAt = this.moment(newVal)
    //       .format('YYYY-MM-DD');
    //   },
    // },
    methods: {
      ...mapActions('VoucherStore', ['editPrice', 'fetchVoucherDetails']),
      goBack() {
        this.$route.fullPath.includes('details') ? this.$router.push({
          name: 'VoucherDetails',
          params: {voucherId: this.$route.params.voucherId},
        }) : this.$router.push({name: 'Vouchers'});
      },
      onSubmit() {
        this.$validator.validateAll()
          .then((isValid) => {
            if (isValid) {
              this.isProcessing = true;
              this.editPrice({
                price: this.price,
                id: this.$route.params.voucherId,
              })
                .then(() => {
                  this.goBack();
                  this.isProcessing = false;
                }, () => {
                  this.isProcessing = false;
                });
            }
          });
      },
    },
  };
</script>

<style scoped>

</style>
